import { DeleteOutlined, FileExcelOutlined, PlusOutlined, PrinterFilled, SearchOutlined, UploadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, DatePicker, Dropdown, Form, Input, Menu, Pagination, Popconfirm, Row, Space, Table, Tooltip, message, Modal } from 'antd';
import dayjs from 'dayjs';
import 'jspdf-autotable';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import {
  getWarehouseMovedBundleSummary,
  deleteBundleInwardList,
  fetchBundleInWardList,
  resetBundleInwardList,
  shiftBundleExcessStock,
} from '../../slices/bundleinword';
import { createActivityLog } from '../../slices/activity-log';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';

function BundleInWardList() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const defaultStart = dayjs().startOf('month');
  const defaultEnd = dayjs();
  const { user: currentUser } = useSelector(state => state.auth);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [search, setSearch] = useState(
    localStorage.getItem('bundle_inward') || '',
  );
  const { data = [], totalRecord, status } = useSelector(state => state.bundleInWard);

  const [inputValue, setInputValue] = useState(
    localStorage.getItem('bundle_inward') || '',
  );
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(100);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [form] = Form.useForm();

  const storedStart = localStorage.getItem('bundleInward_start_date');
  const storedEnd = localStorage.getItem('bundleInward_end_date');
  const [start_date, set_start_date] = useState(
    storedStart ? dayjs(storedStart, 'DD-MM-YYYY') : defaultStart,
  );
  const [end_date, set_end_date] = useState(
    storedEnd ? dayjs(storedEnd, 'DD-MM-YYYY') : defaultEnd,
  );
  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'bundle_no',
    'die_number',
    'bill_to_customer_name',
    'workorder',
    'length',
    'die_image',
    'dimensions',
    'pieces',
    'weight',
    'avg_weight',
    'packing_date',
    'customer',
    'alloy',
    'jobworks',
    'temper',
    'shift',
    'status',
    'hardness',
    'gross_weight',
    'total_weight',
    'total_pieces',
    'total_bundles',
    'dispatch_date',
    'packing_mode',
    'packed_by',
    'remarks',
    'order_no',
    'action',
  ]);

  const ipAddress = useSelector(state => state.ip.ipAddress);
  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);

  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const handleShiftBundleExcessStock = bundleId => {
    const values = {
      bundle_id: [bundleId],
    };
    dispatch(shiftBundleExcessStock({ values }))
      .unwrap()
      .then(result => {
        message.success('Bundle Shifted To Excess Stock Successfully!');
        dispatch(resetBundleInwardList());
        dispatch(
          fetchBundleInWardList({
            page,
            pagesize,
            ...(search && { search: search }),
            ...(orderBy && { ordering: orderBy }),
            ...(startDate && { startDate }),
            ...(endDate && { endDate }),
          }),
        );
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };
  const handleEdit = data => {
    window.open(`/print/${data.id}`, '_blank');
  };

  const handleDelete = async (record) => {
    if (!record?.id) {
      message.error('Missing ID for deletion!');
      return;
    }

    if (record?.status === "Packed") {
      confirmDelete(record?.id);
    } else if (record?.status === "Warehouse") {
      const summaryResponse = await dispatch(getWarehouseMovedBundleSummary(record?.id)).unwrap();

      if (summaryResponse?.success) {
        Modal.warning({
          title: `Bundle Deletion Warning – Linked to Outward Slip`,
          width: 720,
          icon: <InfoCircleOutlined style={{ color: "#faad14" }} />,
          okText: "Confirm Delete",
          cancelText: "Cancel",
          okCancel: true,
          maskClosable: false,
          onOk: () => {
            confirmDelete(record?.id);
          },
          onCancel: () => {
            message.info("Delete cancelled");
          },
          content: (
            <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "10px" }}>
              <p>
                The bundle you are trying to delete already exists in
                <b> Bundle Outward Slip No. {summaryResponse?.data?.slip_no}</b>.
              </p>

              <p>
                This bundle is currently in <b>Warehouse</b> status and has not been
                finally dispatched to the customer.
              </p>

              <p>If you proceed with deletion:</p>

              <ul style={{ paddingLeft: 20 }}>
                <li>The bundle will be removed from current warehouse stock</li>
                <li>The bundle will also be removed from the outward slip</li>
                <li>Any related stock movements will be automatically reversed</li>
              </ul>

              <p style={{ marginTop: 12 }}>
                <b>Please confirm if you want to permanently delete this bundle.</b>
              </p>
            </div>
          ),
        });
      } else {

      }
    } else if (record?.status === "Dispatched") {
      confirmDelete(record?.id);
    } else {
      return false;
    }
  };

  const confirmDelete = async (id) => {
    try {
      dispatch(deleteBundleInwardList(id))
        .unwrap()
        .then(response => {
          if (response && response.success) {
            message.success(response.message);
            dispatch(resetBundleInwardList());
            dispatch(
              fetchBundleInWardList({
                page,
                pagesize,
                ...(search && { search: search }),
                ...(orderBy && { ordering: orderBy }),
                ...(startDate && { startDate }),
                ...(endDate && { endDate }),
              }),
            );
          } else {
            message.error(response.message); // Fallback message
            dispatch(resetBundleInwardList());
            dispatch(
              fetchBundleInWardList({
                page,
                pagesize,
                ...(search && { search: search }),
                ...(orderBy && { ordering: orderBy }),
                ...(startDate && { startDate }),
                ...(endDate && { endDate }),
              }),
            );
          }
        })
        .catch(error => {
          if (typeof error === 'object' && error !== null) {
            const messages = [];
            for (const key in error) {
              if (Array.isArray(error[key])) {
                messages.push(`${key}: ${error[key].join(', ')}`);
              }
            }

            if (messages.length > 0) {
              message.error(messages.join('; '));
            } else {
              message.error('An unknown error occurred.');
            }
          } else if (typeof error === 'string') {
            message.error(error); // Handle string error
          } else if (error instanceof Error) {
            message.error(error.message); // Handle Error object
          } else {
            message.error('An unknown error occurred.');
          }
        });
    } catch (err) {

      message.error("Failed to delete record");
    }
  }

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 70,
      className: 'sr-no-column',
      render: (text, record, index) => (page - 1) * pagesize + index + 1,
    },
    {
      title: 'WorkOrder No.',
      dataIndex: 'order_no',
      key: 'order_no',

      width: 120,
      render: (_, record) => (
        <span>{record.workorder || 'N/A'}</span>
      ),
    },
    {
      title: 'Customer Name',
      dataIndex: 'bill_to_customer_name',
      key: 'bill_to_customer_name',
      width: 120,
      render: (_, record) => (
        <span>{record.customer_name || 'N/A'}</span>
      ),
    },

    {
      title: 'Bundle No.',
      dataIndex: 'bundle_no',
      key: 'bundle_no',
      width: 120,
      render: bundle_no => {
        return <span>{bundle_no ? bundle_no : 'N/A'}</span>;
      },
      sorter: true,
    },
    {
      title: 'Shift',
      dataIndex: 'shift',
      key: 'shift',
      width: 80,
      sorter: true,
      render: shift => {
        return <span>{shift ? shift : 'N/A'}</span>;
      },
    },
    {
      title: 'Profile',
      dataIndex: 'die_number',
      key: 'die_number',
      width: 80,
      render: (_, record) => (
        <span>{record.die_number || 'N/A'}</span>
      ),
    },
    {
      title: 'Length(mm)',
      dataIndex: 'length',
      key: 'length',
      width: 110,
      render: (_, record) => (
        <span>{record.length || 'N/A'}</span>
      ),
    },
    {
      title: 'Profile Description (mm)',
      dataIndex: 'dimensions',
      key: 'dimensions',
      width: 190,
      render: (_, record) => {
        return <span>{record?.die_description || 'N/A'}</span>;
      },
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
      sorter: true,
      width: 90,
      render: pieces => {
        return <span>{pieces ? pieces : 'N/A'}</span>;
      },
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
      sorter: true,
      width: 100,
      render: weight => {
        return <span>{weight ? weight : 'N/A'}</span>;
      },
    },
    {
      title: 'Avg. Wt.',
      dataIndex: 'avg_weight',
      key: 'avg_weight',
      width: 80,
      render: avg_weight => {
        return <span>{avg_weight ? avg_weight : '0'}</span>;
      },
    },
    {
      title: 'Gross Weight',
      dataIndex: 'gross_weight',
      key: 'gross_weight',
      sorter: true,
      width: 100,
      render: gross_weight => {
        return <span>{gross_weight ? gross_weight : 'N/A'}</span>;
      },
    },
    {
      title: 'Packing Date',
      dataIndex: 'packing_date',
      key: 'packing_date',
      width: 140,
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY hh:mm') : 'N/A'}{' '}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: 'Dispatch Date',
      dataIndex: 'dispatch_date',
      key: 'dispatch_date',
      width: 140,
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY hh:mm') : 'N/A'}{' '}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: 'Alloy',
      dataIndex: 'alloy',
      key: 'alloy',
      width: 120,
      render: (_, record) => (
        <span>{`${record?.alloy?.alloy_code} - ${record?.alloy?.standard_name}` || 'N/A'}</span>
      ),
    },
    {
      title: 'Temper',
      dataIndex: 'temper',
      key: 'temper',
      width: 130,
      render: (_, record) => (
        <span>{`${record?.temper?.temper_code_new} - ${record?.temper?.temper_code_old}` || 'N/A'}</span>
      ),
    },
    {
      title: 'Jobwork',
      dataIndex: 'jobworks',
      key: 'jobworks',
      width: 90,
     render: (jobworks) => {
        return Array.isArray(jobworks) && jobworks.length
          ? jobworks.map(item => item.name).join(', ')
          : 'N/A';
      },
    },
    {
      title: 'Packing Type',
      dataIndex: 'packing_mode',
      key: 'packing_mode',
      width: 250,
      render: (packing_mode) => {
        return Array.isArray(packing_mode) && packing_mode.length
          ? packing_mode.map(item => item.name).join(', ')
          : 'N/A';
      },
    },
    {
      title: 'Hardness',
      dataIndex: 'hardness',
      key: 'hardness',
      width: 100,
      render: hardness => {
        return <span>{hardness ? hardness : 'N/A'}</span>;
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: status => {
        return <span>{status ? status : 'N/A'}</span>;
      },
    },
    {
      title: 'Packed By',
      dataIndex: 'packed_by',
      key: 'packed_by',
      width: 120,
      render: (_, record) => {
        return (
          <span>{`${record?.created_by?.first_name} ${record?.created_by?.last_name}` || 'N/A'}</span>
        );
      },
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      key: 'remarks',
      width: 100,
      render: remarks => {
        return <span>{remarks ? remarks : 'N/A'}</span>;
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 140,
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      width: 140,
      render: (_, record) => {
        return (
          <span>{`${record?.created_by?.first_name} ${record?.created_by?.last_name}` || 'N/A'}</span>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: 120,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip placement="top" title={'Shift Bundle To Excess Stock'}>
            <span onClick={() => handleShiftBundleExcessStock(record?.id)}>
              <UploadOutlined style={{ cursor: 'pointer' }} />
            </span>
          </Tooltip>
          {currentUser?.permissions?.permissions?.bundle_inward.includes(
            'print_bundle_inward_copy',
          ) && (
              <Tooltip placement="top" title={'Print'}>
                <span onClick={() => handleEdit(record)}>
                  <PrinterFilled style={{ cursor: 'pointer' }} />
                </span>
              </Tooltip>
            )}

          {currentUser.permissions.permissions.bundle_inward.includes(
            'delete_bundleinward',
          ) && (
              <Link>
                <Tooltip title="Delete">
                  <Popconfirm
                    title="Are you sure you want to delete this record?"
                    onCancel={() => message.info('Action cancelled')}
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => handleDelete(record)} // Correctly access `id`
                  >
                    <DeleteOutlined
                      style={{ cursor: 'pointer', fontSize: '18px' }}
                    />
                  </Popconfirm>
                </Tooltip>
              </Link>
            )}
        </Space>
      ),
    },
  ];

  const filteredColumns = columns?.filter(column =>
    checkedList?.includes(column.key),
  );

  useEffect(() => {
    dispatch(resetBundleInwardList());
    if (search.length) {
      dispatch(
        fetchBundleInWardList({
          page,
          pagesize,
          ...(search && search.length >= 3 && { search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      );
    } else {
      dispatch(
        fetchBundleInWardList({
          page,
          pagesize,
          ...(search && search.length >= 3 && { search }),
          ...(orderBy && { ordering: orderBy }),
          ...(start_date && { start_date: dayjs(start_date).format('DD-MM-YYYY') }),
          ...(end_date && { end_date: dayjs(end_date).format('DD-MM-YYYY') }),
        }),
      );
    }

  }, [dispatch, page, pagesize, search, orderBy, start_date, end_date]);


  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };
  const handlePageSizeChange = (current, size) => {
    console.log(current)
    setPage(1);
    setPageSize(size);
  };
  const debounceTimeout = useRef(null);

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // Debounced search handler
  const debouncedSearch = useCallback(
    debounce(value => {
      dispatch(resetBundleInwardList());
      setSearch(value);
      localStorage.setItem('bundle_inward', value);
    }, 500),
    [dispatch],
  );

  const handleSearch = e => {
    const value = e.target.value;
    setInputValue(value);
    setPage(1);
    localStorage.removeItem('bundleInward_start_date');
    localStorage.removeItem('bundleInward_end_date');
    debouncedSearch(value);
  };
  const resetFilter = () => {
    setPage(1);
    setSearch('');
    setInputValue('');
    localStorage.removeItem('bundle_inward');
  };
  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  const handlePageChange = (newPage, currentPageSize) => {
    setPage(newPage);
    setPageSize(currentPageSize);
    setOrderBy('');
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'bundle_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'bundle_no';
    }
    if (sortField === 'bundle_no' && sortOrder === 'descend') {
      sortingEnumKey = '-bundle_no';
    }
    if (sortField === 'shift' && sortOrder === 'ascend') {
      sortingEnumKey = 'shift';
    }
    if (sortField === 'shift' && sortOrder === 'descend') {
      sortingEnumKey = '-shift';
    }
    if (sortField === 'die_profile' && sortOrder === 'ascend') {
      sortingEnumKey = 'die_profile__die_number';
    }
    if (sortField === 'die_profile' && sortOrder === 'descend') {
      sortingEnumKey = '-die_profile__die_number';
    }
    if (sortField === 'length' && sortOrder === 'ascend') {
      sortingEnumKey = 'length';
    }
    if (sortField === 'length' && sortOrder === 'descend') {
      sortingEnumKey = '-length';
    }
    if (sortField === 'item_name' && sortOrder === 'ascend') {
      sortingEnumKey = 'item_name';
    }
    if (sortField === 'item_name' && sortOrder === 'descend') {
      sortingEnumKey = '-item_name';
    }
    if (sortField === 'pieces' && sortOrder === 'ascend') {
      sortingEnumKey = 'pieces';
    }
    if (sortField === 'pieces' && sortOrder === 'descend') {
      sortingEnumKey = '-pieces';
    }
    if (sortField === 'weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'weight';
    }
    if (sortField === 'weight' && sortOrder === 'descend') {
      sortingEnumKey = '-weight';
    }
    if (sortField === 'average_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'average_weight';
    }
    if (sortField === 'average_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-average_weight';
    }
    if (sortField === 'gross_weight' && sortOrder === 'ascend') {
      sortingEnumKey = 'gross_weight';
    }
    if (sortField === 'gross_weight' && sortOrder === 'descend') {
      sortingEnumKey = '-gross_weight';
    }
    if (sortField === 'packing_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'packing_date';
    }
    if (sortField === 'packing_date' && sortOrder === 'descend') {
      sortingEnumKey = '-packing_date';
    }
    if (sortField === 'dispatch_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'dispatch_date';
    }
    if (sortField === 'dispatch_date' && sortOrder === 'descend') {
      sortingEnumKey = '-dispatch_date';
    }
    if (sortField === 'alloy' && sortOrder === 'ascend') {
      sortingEnumKey = 'alloy_name';
    }
    if (sortField === 'alloy' && sortOrder === 'descend') {
      sortingEnumKey = '-alloy_name';
    }
    if (sortField === 'temper' && sortOrder === 'ascend') {
      sortingEnumKey = 'temper_name';
    }
    if (sortField === 'temper' && sortOrder === 'descend') {
      sortingEnumKey = '-temper_name';
    }
    if (sortField === 'jobworks' && sortOrder === 'ascend') {
      sortingEnumKey = 'jobworks';
    }
    if (sortField === 'jobworks' && sortOrder === 'descend') {
      sortingEnumKey = '-jobworks';
    }
    if (sortField === 'packing_mode' && sortOrder === 'ascend') {
      sortingEnumKey = 'packing_mode';
    }
    if (sortField === 'packing_mode' && sortOrder === 'descend') {
      sortingEnumKey = '-packing_mode';
    }
    if (sortField === 'hardness' && sortOrder === 'ascend') {
      sortingEnumKey = 'hardness';
    }
    if (sortField === 'hardness' && sortOrder === 'descend') {
      sortingEnumKey = '-hardness';
    }
    if (sortField === 'status' && sortOrder === 'ascend') {
      sortingEnumKey = 'status';
    }
    if (sortField === 'status' && sortOrder === 'descend') {
      sortingEnumKey = '-status';
    }
    if (sortField === 'packed_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'packed_by';
    }
    if (sortField === 'packed_by' && sortOrder === 'descend') {
      sortingEnumKey = '-packed_by';
    }
    if (sortField === 'created_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_at';
    }
    if (sortField === 'created_at' && sortOrder === 'descend') {
      sortingEnumKey = '-created_at';
    }
    if (sortField === 'created_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'created_by';
    }
    if (sortField === 'created_by' && sortOrder === 'descend') {
      sortingEnumKey = '-created_by';
    }
    if (sortField === 'updated_at' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_at';
    }
    if (sortField === 'updated_at' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_at';
    }
    if (sortField === 'updated_by' && sortOrder === 'ascend') {
      sortingEnumKey = 'updated_by';
    }
    if (sortField === 'updated_by' && sortOrder === 'descend') {
      sortingEnumKey = '-updated_by';
    }
    return sortingEnumKey;
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr. No.
              </Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="order_no">WorkOrder No.</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="bundle_no">Bundle No.</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="shift">Shift</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="die_number">Profile</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="length">Length</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="dimensions">Profile Description</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="pieces">Pieces</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="weight">Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="avg_weight">Avg. Wt.</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="gross_weight">Gross Weight</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packing_date">Packing Date</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="dispatch_date">Dispatch Date</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="alloy">Alloy</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="temper">Temper</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="jobworks">Surface finish</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packing_mode">Packing Mode</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="hardness">hardness</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="packed_by">Packed By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="remarks">Remarks</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_by">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const allCsvColumns = [
    { header: 'Sr. No.', dataKey: 'SrNo', field: 'SrNo' },
    {
      header: 'WorkOrder No.',
      dataKey: 'order_no',
      field: 'order_no',
    },
    { header: 'Bundle No.', dataKey: 'bundle_no', field: 'bundle_no' },
    {
      header: 'Customer Name',
      dataKey: 'bill_to_customer_name',
      field: 'bill_to_customer_name',
    },
    { header: 'Shift', dataKey: 'shift', field: 'shift' },
    {
      header: 'Profile',
      dataKey: 'die_number',
      field: 'die_number',
    },
    {
      header: 'Length (mm)',
      dataKey: 'length',
      field: 'length',
    },
    {
      header: 'Profile Description (mm)',
      dataKey: 'dimensions',
      field: 'dimensions',
    },
    { header: 'Pieces', dataKey: 'pieces', field: 'pieces' },
    { header: 'Weight', dataKey: 'weight', field: 'weight' },
    { header: 'Avg. Wt.', dataKey: 'average_weight', field: 'average_weight' },
    { header: 'Gross Weight', dataKey: 'gross_weight', field: 'gross_weight' },
    { header: 'Packing Date', dataKey: 'packing_date', field: 'packing_date' },
    { header: 'Dispatch date', dataKey: 'dispatch_date', field: 'dispatch_date' },
    {
      header: 'Alloy',
      dataKey: 'alloy_name',
      field: 'alloy_name',
    },
    { header: 'Temper', dataKey: 'temper_name', field: 'temper_name' },
    {
      header: 'Jobworks',
      dataKey: 'jobworks',
      field: 'jobworks',
    },
    {
      header: 'Packing Type',
      dataKey: 'packing_mode',
      field: 'packing_mode',
    },
    { header: 'Hardness', dataKey: 'hardness', field: 'hardness' },
    { header: 'Status', dataKey: 'status', field: 'status' },
    { header: 'Packed By', dataKey: 'packed_by', field: 'created_by' },
  ];
  const [datalist, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const csvRef = useRef();
  const handleExcel = async () => {
    const count = totalRecord;
    if (count > 0) {
      setIsLoading(true);
      try {
        const response = await dispatch(
          fetchBundleInWardList({
            page: page,
            pagesize: 100,
            ...(search && { search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        ).unwrap();

        setList(response?.results?.data);
        setTimeout(() => {
          if (csvRef.current) {
            csvRef.current.link.click();
          }
          setIsLoading(false);
        }, 300);
      } catch (error) {
        setIsLoading(false);
      }
    }
  };
  const csvHeaders = allCsvColumns.map(col => ({
    label: col.header,
    key: col.dataKey,
  }));

  const csvListData = useMemo(() => {
    return datalist?.map((item, index) => {
      const row = {
        SrNo: index + 1,
      };

      allCsvColumns.forEach(col => {
        switch (col.dataKey) {
          case 'SrNo':
            row['SrNo'] = index + 1;
            break;
          case 'order_no':
            row['order_no'] = item?.workorder?.order_no || 'N/A';
            break;
          case 'bill_to_customer_name':
            row['bill_to_customer_name'] =
              item?.workorder?.customer_name || 'N/A';
            break;
          case 'bundle_no':
            row['bundle_no'] = item?.bundle_no || 'N/A';
            break;
          case 'shift':
            row['shift'] = item?.shift || 'N/A';
            break;
          case 'die_number':
            row['die_number'] =
              item?.workorder_detail?.die_detail?.die_number || 'N/A';
            break;
          case 'length':
            row['length'] =
              item?.workorder_detail?.length || '0';
            break;
          case 'dimensions': {
            const dimensions = [
              item?.workorder_detail?.die_detail?.dimension1,
              item?.workorder_detail?.die_detail?.dimension2,
              item?.workorder_detail?.die_detail?.dimension3,
              item?.workorder_detail?.die_detail?.dimension4,
            ]
              .filter(dim => dim !== null && dim !== '' && dim !== undefined)
              .map(dim => Number(dim)?.toFixed(2))
              .join(' X ');
            row['dimensions'] = dimensions || 'N/A';
            break;
          }
          case 'pieces':
            row['pieces'] = item?.pieces || 'N/A';
            break;
          case 'weight':
            row['weight'] = item?.weight || 'N/A';
            break;
          case 'average_weight':
            row['average_weight'] = item?.avg_weight
              ? item?.avg_weight
              : '0';
            break;
          case 'gross_weight':
            row['gross_weight'] = item?.gross_weight || 'N/A';
            break;
          case 'packing_date':
            row['packing_date'] = item?.packing_date
              ? dayjs(item?.packing_date).format('DD-MM-YYYY hh:mm')
              : 'N/A';
            break;
          case 'dispatch_date':
            row['dispatch_date'] = item?.dispatch_date
              ? dayjs(item?.dispatch_date).format('DD-MM-YYYY hh:mm')
              : 'N/A';
            break;
          case 'alloy_name': {
            const alloyName = item?.workorder_detail?.alloy_detail?.alloy_code || '';
            const standardName = item?.workorder_detail?.alloy_detail?.standard_name || '';
            let alloyString = 'N/A';
            if (alloyName || standardName) {
              alloyString = `${alloyName}${alloyName && standardName ? ' - ' : ''}${standardName}`;
            }
            row['alloy_name'] = alloyString;
            break;
          }
          case 'temper_name': {
            const temperName =
              item?.workorder_detail?.temper_detail?.name ||
              '';
            const code =
              item?.workorder_detail?.temper_detail?.code ||
              '';
            let temperString = 'N/A';
            if (temperName || code) {
              temperString = `${temperName}${temperName && code ? ' - ' : ''}${code}`;
            }
            row['temper_name'] = temperString;
            break;
          }
          case 'jobworks':
            let jobworkType =
              item?.jobworks ||
              'N/A';
            try {
              const parsed = JSON.parse(jobworkType);
              jobworkType =
                Array.isArray(parsed) && parsed.length
                  ? parsed.join(', ')
                  : 'N/A';
            } catch (e) { }
            row['jobworks'] = jobworkType;
            break;
          case 'packing_mode': {
            let packingType =
              item?.packing_mode ||
              'N/A';
            try {
              const parsed = JSON.parse(packingType);
              packingType =
                Array.isArray(parsed) && parsed.length
                  ? parsed.join(', ')
                  : 'N/A';
            } catch (e) { }
            row['packing_mode'] = packingType;
            break;
          }
          case 'hardness':
            row['hardness'] = item?.hardness ? `${item.hardness}` : 'N/A';
            break;
          case 'status':
            row['status'] = item?.status || 'N/A';
            break;
          case 'packed_by': {
            const createdBy = item?.created_by;

            if (createdBy && (createdBy.first_name || createdBy.last_name)) {
              row['packed_by'] = `${createdBy.first_name ?? ''} ${createdBy.last_name ?? ''}`;
            } else {
              row['packed_by'] = 'N/A';
            }
            break;
          }
          default:
            row[col.dataKey] = item?.[col.dataKey] || 'N/A';
        }
      });
      return row;
    });
  }, [datalist, allCsvColumns]);

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Bundle Inward',
        ip_address: ipAddress,
        discription: 'Bundle inward excel download successfully!',
      }),
    );
  };

  return (
    <div className="mainwrap">
      <div className="sticyaction pb-0">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-0"
            justify="space-between"
            align="middle"
            gutter={[5, 5]}
          >
            <Col>
              <h2 style={{ margin: 0 }}>Bundle Inward</h2>
              <div className="bredcrumbwrp">
                <Link onClick={() => navigate(-1)} className="back">
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: 'Bundle Inward' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <div className="flex justify-end items-end gap-4 flex-wrap">
                <Form
                  layout="vertical"
                  autoComplete="off"
                  form={form}
                  className="flex items-end gap-4"
                  initialValues={{
                    start_date: start_date,
                    end_date: end_date,
                  }}
                >
                  <Form.Item
                    name="start_date"
                    label="Start Date"
                    className="mb-0"
                  >
                    <DatePicker
                      style={{ width: 150 }}
                      format="DD-MM-YYYY"
                      value={
                        start_date ? moment(start_date, 'DD-MM-YYYY') : null
                      }
                      onChange={date => {
                        set_start_date(date);
                        if (date) {
                          localStorage.setItem(
                            'bundleInward_start_date',
                            date.format('DD-MM-YYYY'),
                          );
                        }
                      }}
                    />
                  </Form.Item>
                  <Form.Item name="end_date" label="End Date" className="mb-0">
                    <DatePicker
                      style={{ width: 150 }}
                      format="DD-MM-YYYY"
                      disabledDate={current =>
                        start_date
                          ? current.isBefore(
                            moment(start_date, 'DD-MM-YYYY'),
                            'day',
                          ) ||
                          current.isSame(
                            moment(start_date, 'DD-MM-YYYY'),
                            'day',
                          )
                          : false
                      }
                      onChange={date => {
                        set_end_date(date);
                        if (date) {
                          localStorage.setItem(
                            'bundleInward_end_date',
                            date.format('DD-MM-YYYY'),
                          );
                        }
                      }}
                    />
                  </Form.Item>
                  {(start_date || end_date) && (
                    <Form.Item className="mb-0">
                      <Button
                        type="primary"
                        onClick={() => {
                          setPage(1);
                          dispatch(resetBundleInwardList());
                          form.resetFields();
                          set_start_date(null);
                          set_end_date(null);
                          form.setFieldsValue({
                            start_date: null,
                            end_date: null,
                          });
                          localStorage.removeItem('bundleInward_start_date');
                          localStorage.removeItem('bundleInward_end_date');
                        }}
                      >
                        Reset
                      </Button>
                    </Form.Item>
                  )}
                </Form>
                <Space size="small">
                  <Input
                    placeholder="Search"
                    className="searchbox"
                    prefix={<SearchOutlined />}
                    value={inputValue}
                    style={{ width: 200 }}
                    onChange={handleSearch}
                  />
                  <Tooltip title="Filter">
                    <Button
                      type="primary"
                      disabled={!search}
                      className="iconlink"
                      onClick={resetFilter}
                    >
                      <FilterIcon />
                    </Button>
                  </Tooltip>
                  {currentUser.permissions.permissions.bundle_inward.includes(
                    'download_bundle_inward_excel_copy',
                  ) && (
                      <Tooltip placement="top" title={'Export Excel'}>
                        <Button
                          type="primary"
                          className="iconlink"
                          style={{ width: '10px' }}
                          onClick={handleExcel}
                          disabled={isLoading}
                        >
                          <CSVLink
                            headers={csvHeaders}
                            data={csvListData}
                            filename="bundle-inward-list.csv"
                            ref={csvRef}
                            style={{ display: 'none' }}
                            onClick={activityLog}
                          />
                          <FileExcelOutlined />
                        </Button>
                      </Tooltip>
                    )}
                  {currentUser.permissions.permissions.bundle_inward.includes(
                    'add_bundleinward',
                  ) && (
                      <Link to="/add-bundle-inward">
                        <Tooltip title="Pack bundles">
                          <Button type="primary" icon={<PlusOutlined />}>
                            Pack Bundles
                          </Button>
                        </Tooltip>
                      </Link>
                    )}
                  <div className="gridiconswrap">
                    <Tooltip placement="topLeft" title="Column Filter Options">
                      <Dropdown
                        overlay={columnMenu}
                        trigger={['click']}
                        placement="bottomRight"
                        visible={dropdownVisible}
                        onVisibleChange={setDropdownVisible}
                      >
                        <Button
                          type="primary"
                          icon={<ColumnList />}
                          onClick={e => e.preventDefault()}
                        />
                      </Dropdown>
                    </Tooltip>
                  </div>
                </Space>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <div className="tablewrp">
        <Table
          rowKey="id"
          columns={filteredColumns}
          dataSource={Array.isArray(data) ? data : []}
          pagination={false}
          loading={{
            spinning: !Array.isArray(data) || status === 'loading',
          }}
          scroll={{ x: '2400px' }}
          onChange={handleTableChange}
        />
      </div>

      <Pagination
        current={page}
        pageSize={pagesize}
        total={totalRecord}
        showSizeChanger
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={['20', '50', '100']}
        showTotal={total => `Total ${total} items`}
        onChange={handlePageChange}
        locale={{ items_per_page: 'Items / Page' }}
      />
    </div>
  );
}

export default BundleInWardList;
